import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiFetch } from "../utils/api";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email.trim() || !password.trim()) {
      setError("Please enter email and password.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiFetch("/auth/login", {
        method: "POST",
        body: JSON.stringify({
          email,
          password,
          device_id: "web_dashboard_fcm_dummy_token",
        }),
      });

      login(response.user, response.access_token, response.refresh_token);
      const role = response.user.role;
      if (role === "superadmin" || role === "admin" || role === "operator") {
        navigate("/");
      } else if (role === "driver") {
        navigate("/driver-dashboard");
      } else {
        navigate("/parent-dashboard");
      }
    } catch (err) {
      setError(err.message || "Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          background: "var(--accent-purple)",
          filter: "blur(150px)",
          opacity: 0.15,
          top: "10%",
          left: "20%",
          borderRadius: "50%",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          background: "var(--accent-blue)",
          filter: "blur(150px)",
          opacity: 0.15,
          bottom: "20%",
          right: "25%",
          borderRadius: "50%",
        }}
      ></div>

      <div
        className="glass-panel"
        style={{
          width: "100%",
          maxWidth: "420px",
          padding: "48px",
          position: "relative",
          zIndex: 10,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h1
            className="text-gradient"
            style={{ fontSize: "2rem", marginBottom: "8px" }}
          >
            School Bus Tracker
          </h1>
          <p style={{ color: "var(--text-muted)", marginBottom: "16px" }}>
            Admin login with email and password
          </p>
        </div>

        {error && (
          <div
            style={{
              background: "rgba(211, 47, 47, 0.08)",
              borderLeft: "4px solid var(--danger)",
              padding: "12px 16px",
              borderRadius: "4px",
              marginBottom: "24px",
              color: "var(--danger)",
              fontSize: "0.9rem",
            }}
          >
            {error}
          </div>
        )}

        {message && (
          <div
            style={{
              background: "rgba(56, 142, 60, 0.08)",
              borderLeft: "4px solid var(--success)",
              padding: "12px 16px",
              borderRadius: "4px",
              marginBottom: "24px",
              color: "var(--success)",
              fontSize: "0.9rem",
            }}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleAdminLogin}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="admin@bustrack.school"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="btn-primary btn-block"
            style={{ marginTop: "32px" }}
            disabled={loading}
          >
            {loading ? "Authenticating..." : "Secure Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
